<template>
  <b-modal
    id="gamification-subscribe-modal"
    size="lg"
    centered
    footer-class="justify-content-between px-5"
    @hidden="agree = false">
    <div class="content-container">
      <div class="content-header d-flex align-items-center">
        <div class="content-logo d-inline-flex align-items-center">
          <b-img :src="require('@/assets/images/marketplace/perx_logo.svg')" fluid></b-img>
        </div>
        <span class="ml-4">
          <h5 class="mb-0">Gamification</h5>
          <small class="text-muted">Powered by PERX</small>
        </span>
      </div>
      <div class="content-details mt-5">
        <h5>Condition of Use</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

        <h5>Privacy</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.</p>
      </div>
    </div>
    <template slot="modal-footer">
      <b-form-checkbox v-model="agree">I agree to terms and conditions</b-form-checkbox>
      <b-button :variant="!agree ? null : 'primary'" :disabled="!agree">Complete Order</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "GamificationSubscribeModal",
  data() {
    return {
      agree: false
    }
  }
}
</script>

<style lang="scss">
#gamification-subscribe-modal {
  .modal-title::after {
    display: none;
  }
  .content-container {
    .content-header {
      .content-logo {
        width: 80px;
        height: 80px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(150, 155, 165, 0.25);
      }
    }
    .content-details {
      max-height: 339px;
      overflow-y: auto;
    }
    h5 {
      font-family: MainFontBold, sans-serif;
      font-size: 20px;
      color: #2F3941;
    }
    p {
      font-size: 14px;
      color: #49545C;
    }
  }
  .modal-footer {
    .custom-control-label {
      &::before {
        top: 4px !important;
      }
      &::after {
        top: 4px !important;
      }
    }
    .btn {
      font-size: 14px !important;
      font-family: MainFontBold, sans-serif !important;
      &.btn-secondary.disabled {
        color: #87929D;
        background: #D8DCDE;
      }
    }
  }
}
</style>
